import {AppStore} from "../../desktop";
import {ReportsActionTypes} from "./types";
import {InvoicePaymentPeriod} from "../../models/reports/InvoicePaymentPeriod";

export const actionReportsInvoicesPaymentsFetch = () => {
	AppStore.dispatch({type: ReportsActionTypes.FETCH_INVOICE_AND_PAYMENTS_REQUEST, payload: null})
}

export const actionReportsInvoicesPaymentsCompleted = (data: any[]) => {
	AppStore.dispatch({type: ReportsActionTypes.FETCH_INVOICE_AND_PAYMENTS_COMPLETED, payload: data})
}

export const actionReportsSetFromDate = (data: Date) => {
	AppStore.dispatch({type: ReportsActionTypes.SET_FROM_DATE, payload: data})
}

export const actionReportsSetToDate = (data: Date) => {
	AppStore.dispatch({type: ReportsActionTypes.SET_TO_DATE, payload: data})
}

export const actionReportsServicesFetch = (fromDate: Date, toDate: Date) => {
	AppStore.dispatch({type: ReportsActionTypes.FETCH_SERVICES_REQUEST, payload: {fromDate: fromDate, toDate: toDate}})
}

export const actionReportsServicesCompleted = (data: any[]) => {
	AppStore.dispatch({type: ReportsActionTypes.FETCH_SERVICES_COMPLETED, payload: data})
}

// export const actionReportsSetDate = (data: InvoicePaymentPeriod[]) => {
// 	AppStore.dispatch({type: ReportsActionTypes.SET_DATA, payload: data})
// }
